<template>
  <section class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
    <h2 class="text-lg font-semibold text-ink">Settings</h2>
    <p class="text-sm text-muted">Manage your account, preferences, and support.</p>

    <div class="mt-6 grid gap-4 md:grid-cols-2">
      <button
        v-for="item in accountItems"
        :key="item.label"
        type="button"
        class="flex items-center justify-between gap-3 rounded-2xl border border-gray-100 bg-white px-4 py-4 text-left text-sm font-semibold text-ink shadow-sm transition hover:border-brand"
      >
        <span class="flex items-center gap-3">
          <span class="flex h-9 w-9 items-center justify-center rounded-xl bg-[#FFE5EC] text-brand">
            <i :class="item.icon"></i>
          </span>
          <span>{{ item.label }}</span>
        </span>
        <i class="ri-arrow-right-s-line text-lg text-muted"></i>
      </button>
    </div>

    <div class="my-8 h-px w-full bg-gray-100"></div>

    <div class="grid gap-4 md:grid-cols-2">
      <button
        v-for="item in supportItems"
        :key="item.label"
        type="button"
        class="flex items-center justify-between gap-3 rounded-2xl border border-gray-100 bg-white px-4 py-4 text-left text-sm font-semibold text-ink shadow-sm transition hover:border-brand"
      >
        <span class="flex items-center gap-3">
          <span class="flex h-9 w-9 items-center justify-center rounded-xl bg-[#FFE5EC] text-brand">
            <i :class="item.icon"></i>
          </span>
          <span>{{ item.label }}</span>
        </span>
        <i class="ri-arrow-right-s-line text-lg text-muted"></i>
      </button>
    </div>
  </section>
</template>

<script setup>
const accountItems = [
  { label: 'Profile', icon: 'ri-briefcase-line' }, 
  { label: 'Change Password', icon: 'ri-lock-2-line' }
]

const supportItems = [
  { label: 'About Us', icon: 'ri-information-line' },
  { label: 'Support', icon: 'ri-customer-service-2-line' },
  { label: 'Faqs', icon: 'ri-question-line' },
  { label: 'Terms of Use', icon: 'ri-file-text-line' },
  { label: 'Privacy Policy', icon: 'ri-shield-check-line' }, 
  { label: 'Logout', icon: 'ri-logout-box-r-line' },
  { label: 'Delete Account', icon: 'ri-delete-bin-6-line' }
]
</script>
